import { AbstractControl } from '@angular/forms';
import * as parser from 'parse-address';

export function validateAddress(c: AbstractControl) {
  // todo:mm: extract this out
  const address = parser.parseLocation(c.value);

  const valid = !!(
    address &&
    address.number &&
    address.street &&
    address.city &&
    address.state &&
    address.zip
  );

  return valid ? null : { address: true };
}
